/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import { ReservationTooltipRowData } from "../../types";
import { ReservationTooltipRow } from "./ReservationTooltipRow";
import { ReservationTooltipTable } from "./ReservationTooltipTable";

type Props = {
  values: ReservationTooltipRowData[];
  suffix: string;
};

export function ReservationTooltip({ values, suffix }: Props) {
  return (
    <ReservationTooltipTable>
      {values.map(({ key, value, color, hasBottomBorder }) => (
        <ReservationTooltipRow
          key={`${key}${value}`}
          infoLabel={key}
          infoValue={`${value}${suffix ?? ""}`}
          color={color}
          css={{
            borderBottom: hasBottomBorder
              ? `1px solid ${theme.color.border.border01}`
              : "inherit",
          }}
        />
      ))}
    </ReservationTooltipTable>
  );
}
